import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import ProductsView from "../views/Products/View.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/p/:id",
    name: "ProductsView",
    component: ProductsView
  },
  {
    path: "/admin",
    name: "AdminLogin",
    component: () =>
      import(/* webpackChunkName: "adminLogin" */ "../views/Admin/Login.vue")
  },
  {
    path: "/admin/products",
    name: "AdminProducts",
    component: () =>
      import(
        /* webpackChunkName: "adminProducts" */ "../views/Admin/Products/Index.vue"
      )
  },
  {
    path: "/admin/products/create",
    name: "AdminProductsCreate",
    component: () =>
      import(
        /* webpackChunkName: "adminProductsCreate" */ "../views/Admin/Products/Form.vue"
      )
  },
  {
    path: "/admin/products/:id",
    name: "AdminProductsEdit",
    component: () =>
      import(
        /* webpackChunkName: "adminProductsEdit" */ "../views/Admin/Products/Form.vue"
      )
  },
  {
    path: "/admin/users",
    name: "AdminUsers",
    component: () =>
      import(
        /* webpackChunkName: "adminUsers" */ "../views/Admin/Users/Index.vue"
      )
  },
  {
    path: "/admin/users/create",
    name: "AdminUsersCreate",
    component: () =>
      import(
        /* webpackChunkName: "adminUsersCreate" */ "../views/Admin/Users/Form.vue"
      )
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.path.indexOf("/admin/") === 0 && !store.getters.isAdmin()) {
    next("/admin");
    return;
  }
  next();
});
export default router;
